<template>
  <div class="profile">
    <profile-header :edit="$route.path === '/home/profile/edit'">
      <div class="profile_avatar">
        <img class="avatar" :src="userDetails.avatar" alt="">
        <router-link class="edit-icon" v-if="profilePath" to="/home/profile/edit">
          <img src="static/images/edit_ico.svg" alt="">
        </router-link>
      </div>
      <div class="user_info">
        <span class="name">{{ userDetails.username }}</span>
        <span class="name msisdn_num" v-if="showMsisdnInProfilePage">{{ userDetails.msisdn }}</span>
      </div>
      <facebook-login v-if="hasFb()"
                      :enteredUsername="userDetails.username"
                      :errorsInFb="errorInFb"
                      @errorsUpdated="methodForEvent($event)"
                      :type="fbActionType">
      </facebook-login>
    </profile-header>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ProfileHeader from '@/components/home/profile/ProfileHeader';
import FacebookLogin from '@/components/visitor/FacebookLogin';

export default {
  name: 'profile',
  components: {
    ProfileHeader,
    FacebookLogin,
  },
  data() {
    return {
      fbActionType: 'connect',
      errorInFb: false,
    };
  },
  created() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
    ]),
    methodForEvent(event) {
      this.errorInFb = event;
    },
    hasFb() {
      return this.$route.path === '/home/profile' && !this.userDetails.facebookId && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'profilePath',
      'showMsisdnInProfilePage',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue